import React from 'react';
import RichtextParser from '../../utils/richtext-parser';
import styled, { css } from 'styled-components';
import CheckInCircle from '../../images/svg/check-in-circle.svg';
import mq from '../../utils/mq';

const BenefitItemContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 20px;
  ${mq.mobile(css`
    gap: 16px;
  `)};
`;

const BenefitItemIcon = styled.div`
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  color: #8a55fb;
  svg {
    width: 100%;
    height: 100%;
  }
  ${mq.mobile(css`
    width: 24px;
    height: 24px;
  `)};
`;

const BenefitItemContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: flex-start;
  justify-content: flex-start;
`;

const BenefitItemTitle = styled.h3`
  color: #161616;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 125%;
  letter-spacing: -0.48px;
  ${mq.mobile(css`
    font-size: 20px;
  `)};
`;

const BenefitItemBody = styled.div`
  color: #666;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 160%;
  letter-spacing: -0.4px;
  text-wrap: pretty;
  ${mq.mobile(css`
    font-size: 18px;
  `)};
`;

export default function BenefitItem({
  title,
  body
}: {
  title: string;
  body: any;
}) {
  return (
    <BenefitItemContainer>
      <BenefitItemIcon>
        <CheckInCircle />
      </BenefitItemIcon>
      <BenefitItemContent>
        <BenefitItemTitle>{title}</BenefitItemTitle>
        <BenefitItemBody
          dangerouslySetInnerHTML={{
            __html: RichtextParser(body)
          }}
        />
      </BenefitItemContent>
    </BenefitItemContainer>
  );
}
